import { LOADING_STATES } from "../../../../../../features/loading";

import { IFlyerDetailState } from "./flyer-detail-state.interface";

export function createFlyerDetailState(): IFlyerDetailState {
  return {
    currentTab: 0,
    errors: null,
    flyer: null,
    formErrors: null,
    isPageExportModalOpen: false,
    loading: LOADING_STATES.default,
    saving: false,
  };
}
